// @ts-check
import { defineStore, acceptHMRUpdate } from 'pinia'
import { ref } from 'vue'

export const usePolicyMenuStore = defineStore('sysAdminMenuStore', () => {

    const menuList = ref([
        {
            menuName: '이용약관',
            menuUrl: '/policy',
            open: false,
            child: [],
        },
        {
            menuName: '개인정보처리방침',
            menuUrl: '/personal',
            open: false,
            child: [],
        },
        {
            menuName: '이메일무단수집거부',
            menuUrl: '/emailRejection',
            open: false,
            child: [],
        },
    ])
    return {
        menuList,
    }
})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(usePolicyMenuStore, import.meta.hot))
}
